import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="bg-white px-4 pb-4 pt-4" data-id="element-79" data-mp="9k0fha3kwjqp">
      <div className="mx-auto max-w-3xl text-center" data-id="element-80" data-mp="9ipc3be1pe04">
        <h1 className="mb-2 font-display text-[19px] font-extrabold uppercase leading-tight text-brand-ink sm:text-4xl" data-id="element-81" data-mp="4mrul1r1q1lr">
          Il sistema completo per imparare, progettare e gestire la domotica
        </h1>
        <p className="mx-auto mb-1 max-w-2xl text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-82" data-mp="xbpcv4v9byei">
          Smetti di perdere ore tra video, tutorial, forum e informazioni sparse cercando di capire
          come creare una Smart Home che funzioni davvero.
        </p>
        <p className="mx-auto mb-2 max-w-2xl text-[13px] font-semibold leading-snug text-brand-ink sm:text-base" data-id="element-83" data-mp="3d1sa6w93nhsl">
          Finalmente tutto ciò che ti serve è organizzato in un unico sistema pratico e progressivo.
        </p>

        <a href={OFFER_ANCHOR} className="mb-2 block" aria-label="Vai alla sezione di acquisto" data-id="element-84" data-mp="3j9283w7ie4z8">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[300px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-sm" data-id="element-85" data-mp="3o73p8bldju82" />
        </a>

        <CTAButton className="mx-auto mb-2 max-w-md" data-id="element-86" data-mp="30hho3ilfz4xf">🚀 SÌ! VOGLIO IL MIO SISTEMA ORA</CTAButton>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-brand-ink sm:text-sm" data-id="element-87" data-mp="3599jq7jgg0uf">
          <span className="flex items-center gap-1" data-id="element-88" data-mp="2qleoaje2bidn">
            <StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-89" data-mp="2viojkfo4uo9e" />
            ⭐⭐⭐⭐⭐ 4,9/5 — Recensioni Verificate
          </span>
          <span className="flex items-center gap-1" data-id="element-90" data-mp="2hjymh01bcol1">
            <ShieldCheckIcon className="h-4 w-4 text-brand-orange" aria-hidden="true" data-id="element-91" data-mp="2ll0eavswhycz" />
            🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni — Zero Rischi
          </span>
        </div>
      </div>
    </section>;
}